import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {Link, useNavigate} from "react-router-dom";
import Error404 from "../../../../../../Error404";
import {ElementStyle, FieldStyle} from "../../../../../../../layouts/styles";
import {TxtTitles} from "../../../../../../../helpers/breadCrumbs";
import DarkCard from "../../../../../../../components/card/DarkCard";
import styled from "styled-components";
import {projectsCurrentListAPI} from "../../../../../../../services/api/projectCurrent";


const ProfitLoss = styled.span `
    color: #fff;
    font-weight: bold;
    background-color: ${props => props.profit_loss > 0 ? '#69b41f' : props.profit_loss === 0 ? '#636363' : '#b41f23'};
    border-radius: 50px 50px;
    padding: 2px 12px;
`

const titleField = {
    id: "project.id_title",
    name: "project.project_name_title",
    start_date: "project.project_start_date_title",
    project_cost: "project.project_project_cost_title",
    profit_loss: "project.project_project_profit_loss_title",
}


export default function ProjectsCurrentList() {
    const { t } = useTranslation()
    const [projectsCurrents, setprojectsCurrents] = useState([])
    const navigate = useNavigate();

    useEffect(() => {
        const initData = async () => {
            try {
                const response = await projectsCurrentListAPI()
                if (response.status === 200) {
                    setprojectsCurrents(response.data)
                } else return <Error404 />
            } catch (e) {
                console.error(e);
                navigate('/network-error');
            }
        }
        initData()
    }, [])

    const handleClick = (pk) => {navigate("/projects/current/"+pk)}

    const profit_loss = (project) => (
        project && project.totaling
            ? project.totaling.clientSum - project.totaling.estroSum
            : "0.00"
    )

    return (<>
        <DarkCard classNames='mb-3 row'>
            <p className="m-0 p-0 breadcrumbs">
                <span className="txt">{t("menu.projects",{ ns: 'menu' })}</span> &#9656;
                <Link to={"/projects/currents-list"}>{t("menu.current_projects",{ ns: 'menu' })}</Link>
            </p>
        </DarkCard>

        <DarkCard classNames='mb-3 row'>
            <h1 className='mt-0 p-0'>{t("project.projects_current_title")}</h1>

            {projectsCurrents.length > 0
                ? projectsCurrents.map((project) => (
                    <ElementStyle className={"d-flex flex-column"} key={project.id}>
                        <div className="d-flex flex-row flex-wrap flex-md-nowrap py-1" style={{width: '95%'}}>
                            <FieldStyle width="13%" className="p-1">
                                <div>
                                    <TxtTitles>{t(titleField.id)}</TxtTitles>
                                    <a onClick={() => {
                                        handleClick(project.id)
                                    }}><b>P{project.id}</b></a>
                                </div>
                            </FieldStyle>

                            <FieldStyle className="p-1">
                                <div>
                                    <TxtTitles>{t(titleField.name)}</TxtTitles>
                                    <a onClick={() => {
                                        handleClick(project.id)
                                    }}><b>{project.name}</b></a>
                                </div>
                            </FieldStyle>

                            <FieldStyle className="p-1">
                                <div>
                                    <TxtTitles>{t(titleField.start_date)}</TxtTitles>
                                    {project.start_date ? project.start_date : "-----"}
                                </div>
                            </FieldStyle>

                            <FieldStyle className="p-1">
                                <div>
                                    <TxtTitles>{t(titleField.project_cost)}</TxtTitles>
                                    {project.totaling.totalSum.replace(/\B(?=(\d{3})+(?!\d))/g, " ")} €
                                </div>
                            </FieldStyle>

                            <FieldStyle className="p-1">
                                <div>
                                    <ProfitLoss profit_loss={profit_loss(project)} >
                                        {profit_loss(project).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, " ")} €
                                    </ProfitLoss>
                                </div>
                            </FieldStyle>

                        </div>
                    </ElementStyle>
                  ))
                : <p>{t("project.no_data")}</p>
            }

        </DarkCard>
    </>)
}


